import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { UserProfileComponent } from 'src/app/components/user/user-profile.component';
import { ContractsComponent } from './contract-list/contracts-list.component';
import { ContractsViewComponent } from './contracts-view/contracts-view.component';
import { ContractsAccessListComponent } from './contract-access/contract-access-list/contract-access-list.component';

export const routes: Route[] = [
    {
        path: '',
        component: ContractsComponent,
        data: { pageTitle: 'MANAGE_CONTRACTS' }
    },
    {
        path: 'access-requests',
        component: ContractsAccessListComponent,
        data: { pageTitle: 'ACCESS_REQUESTS' }
    },
    {
        path: ':id', 
        component: ContractsViewComponent,
        data: { pageTitle: 'CONTRACT_DETAILS' } 
    }
]

@NgModule({
    declarations: [],
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
    providers: [],
})
export class ContractsRoutingModule {}